/* ===== MOBILE MENU ===== */
const menuToggle = document.getElementById('menu-toggle');
const mobileNav  = document.getElementById('mobile-nav');
if (menuToggle && mobileNav) {
  menuToggle.addEventListener('click', () => {
    mobileNav.classList.toggle('open');
    mobileNav.setAttribute('aria-hidden', !mobileNav.classList.contains('open'));
  });
}

/* ===== STICKY HEADER ===== */
const header = document.getElementById('site-header');
if (header) {
  window.addEventListener('scroll', () => {
    header.style.boxShadow = window.scrollY > 10
      ? '0 2px 16px rgba(0,0,0,0.12)'
      : '0 1px 8px rgba(0,0,0,0.06)';
  }, { passive: true });
}

/* ===== CART HELPERS ===== */
function updateCartCount(count) {
  const el = document.getElementById('cart-count');
  if (!el) return;
  el.textContent = count;
  el.style.display = count > 0 ? 'flex' : 'none';
}

async function fetchCart() {
  return fetch('/cart.js').then(r => r.json());
}

function money(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + ' €';
}

/* ===== MINI-CART DRAWER ===== */
function buildDrawer() {
  if (document.getElementById('mini-cart-drawer')) return;
  const overlay = document.createElement('div');
  overlay.id = 'cart-overlay';
  overlay.onclick = closeDrawer;

  const drawer = document.createElement('div');
  drawer.id = 'mini-cart-drawer';
  drawer.innerHTML = `
    <div class="mcd-header">
      <span class="mcd-title">Votre panier</span>
      <button class="mcd-close" onclick="closeDrawer()">&#x2715;</button>
    </div>
    <div class="mcd-body" id="mcd-body"></div>
    <div class="mcd-footer" id="mcd-footer"></div>`;

  document.body.appendChild(overlay);
  document.body.appendChild(drawer);
}

function openDrawer() {
  document.getElementById('mini-cart-drawer').classList.add('open');
  document.getElementById('cart-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeDrawer() {
  const d = document.getElementById('mini-cart-drawer');
  const o = document.getElementById('cart-overlay');
  if (d) d.classList.remove('open');
  if (o) o.classList.remove('open');
  document.body.style.overflow = '';
}

async function refreshDrawer() {
  const cart = await fetchCart();
  updateCartCount(cart.item_count);

  const body = document.getElementById('mcd-body');
  const footer = document.getElementById('mcd-footer');
  if (!body || !footer) return;

  if (cart.item_count === 0) {
    body.innerHTML = '<p class="mcd-empty">Votre panier est vide.</p>';
    footer.innerHTML = `<a href="/collections/all" class="btn btn--primary btn--full">Voir le catalogue</a>`;
    return;
  }

  body.innerHTML = cart.items.map(item => `
    <div class="mcd-item">
      <img src="${item.image ? item.image.replace(/(\.\w+)$/, '_100x100$1') : ''}" alt="${item.title}" class="mcd-item-img">
      <div class="mcd-item-info">
        <p class="mcd-item-title">${item.product_title}</p>
        <p class="mcd-item-price">${money(item.line_price)}</p>
        <div class="mcd-item-qty">
          <button onclick="changeQty(${item.key}, ${item.quantity - 1})">-</button>
          <span>${item.quantity}</span>
          <button onclick="changeQty(${item.key}, ${item.quantity + 1})">+</button>
          <button class="mcd-remove" onclick="changeQty(${item.key}, 0)">&#x2715;</button>
        </div>
      </div>
    </div>`).join('');

  const freeAt = 6000;
  const remaining = freeAt - cart.total_price;
  const shippingBar = remaining > 0
    ? `<div class="mcd-shipping-bar"><span>Plus que <strong>${money(remaining)}</strong> pour la livraison gratuite</span><div class="mcd-bar-track"><div class="mcd-bar-fill" style="width:${Math.min(100,(cart.total_price/freeAt)*100)}%"></div></div></div>`
    : `<div class="mcd-shipping-bar mcd-shipping-ok">&#x2705; Livraison gratuite incluse !</div>`;

  footer.innerHTML = `
    ${shippingBar}
    <div class="mcd-subtotal">
      <span>Sous-total</span>
      <span><strong>${money(cart.total_price)}</strong></span>
    </div>
    <a href="/checkout" class="btn btn--primary btn--full btn--lg">Passer la commande &rarr;</a>
    <a href="/cart" class="mcd-view-cart">Voir le panier complet</a>`;
}

async function changeQty(key, qty) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  });
  refreshDrawer();
}

/* ===== PRODUCT PAGE — AJAX ADD TO CART ===== */
const productForm = document.getElementById('product-form');
if (productForm) {
  buildDrawer();
  productForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = productForm.querySelector('button[type="submit"]');
    const original = btn.innerHTML;
    btn.innerHTML = '<span class="btn-spinner"></span> Ajout...';
    btn.disabled = true;

    try {
      const formData = new FormData(productForm);
      const body = Object.fromEntries(formData.entries());
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      if (!res.ok) throw new Error('Erreur');
      btn.innerHTML = '&#x2713; Ajouté !';
      btn.style.background = '#15803d';
      await refreshDrawer();
      openDrawer();
    } catch(err) {
      btn.innerHTML = 'Erreur — réessayer';
      btn.style.background = '#dc2626';
    }

    setTimeout(() => {
      btn.innerHTML = original;
      btn.style.background = '';
      btn.disabled = false;
    }, 2500);
  });
}

/* ===== COLLECTION CARDS — AJAX ADD TO CART ===== */
document.querySelectorAll('.product-card__footer form').forEach(form => {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    const original = btn.textContent;
    btn.textContent = '...';
    btn.disabled = true;
    try {
      const data = Object.fromEntries(new FormData(form).entries());
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      btn.textContent = '✓ Ajouté !';
      if (!document.getElementById('mini-cart-drawer')) buildDrawer();
      await refreshDrawer();
      openDrawer();
    } catch(err) { btn.textContent = 'Erreur'; }
    setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 2000);
  });
});
/* ===== FACEBOOK PIXEL EVENTS ===== */
function fbTrack(event, data) {
  if (typeof fbq !== 'undefined') fbq('track', event, data);
}

// AddToCart — product page
var _origProductSubmit = null;
(function() {
  var pf = document.getElementById('product-form');
  if (!pf) return;
  pf.addEventListener('submit', function() {
    var price = pf.querySelector('[data-price]');
    var variantId = pf.querySelector('[name="id"]');
    fbTrack('AddToCart', {
      content_ids: [variantId ? variantId.value : ''],
      content_type: 'product',
      value: window.__productPrice || 0,
      currency: 'EUR'
    });
  }, true);
})();

// InitiateCheckout — checkout buttons
document.querySelectorAll('[name="checkout"], a[href="/checkout"]').forEach(function(el) {
  el.addEventListener('click', function() {
    fbTrack('InitiateCheckout', { currency: 'EUR' });
  });
});